module.exports = __webpack_public_path__ + "static/media/LinkedIn_logo_initials.3f60edfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Contact/contact-images/LinkedIn_logo_initials.png
// module id = 263
// module chunks = 0